jQuery(document).ready(function ($) {
    // console.log("✅ jQuery is loaded and script is running.");

    // Prevent spaces and allow only numeric input
    $('#orderPhone').on('input', function () {
        let value = $(this).val().replace(/\D/g, ''); // Remove non-numeric characters
        $(this).val(value.substring(0, 10)); // Limit to 10 digits
    });

    $('#getOrderDetailsButton').on('click', function (event) {
        event.preventDefault();
        // console.log("🟢 Get Order Details button clicked!");

        let phoneNumber = $('#orderPhone').val().trim();

        // Validate input
        if (!phoneNumber || phoneNumber.length !== 10) {
            // console.warn("⚠️ Invalid phone number.");
            alert("Please enter a valid 10-digit phone number. Don't USE +91 ");
            return;
        }

        // console.log("🔍 Fetching order details for phone:", phoneNumber);
        fetchOrderByPhone(phoneNumber);
    });
});

function fetchOrderByPhone(phoneNumber) {
    // console.log("📡 Sending request to phone.php for phone:", phoneNumber);

    const apiUrl = `https://orientaledumedgroup.com/shopify-proxy/phone-api.php?phone=${encodeURIComponent(phoneNumber)}&t=${Date.now()}`;

    // console.log(`Requesting URL: ${apiUrl}`); // Debug URL

    fetch(apiUrl, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        },
        cache: 'no-store' // Bypass cache to ensure fresh data
    })
    .then(response => {
        // console.log("📥 API Response Received. Status:", response.status, response.statusText);
        if (!response.ok) {
            throw new Error(`API Error: ${response.status} ${response.statusText}`);
        }
        return response.json();
    })
    .then(data => {
        // console.log("📦 Orders data received:", data);

        const container = document.getElementById('orderData');
        const trackbtn = document.getElementById('getOrderDetailsButton');
        container.innerHTML = ''; // Clear previous results
        container.classList.remove("d-none"); // Show the container
        trackbtn.classList.add("d-none"); // Add the new class


        if (!data.orders || data.orders.length === 0) {
            console.warn("❌ No order found for phone:", phoneNumber);
            container.innerHTML = `<p style="color: red; font-weight: bold;">Order Not Found with this Number. Please check and try again.</p>`;
            return;
        }

        // console.log("✅ Order Found:", data.orders[0]);
        displayOrder(data.orders[0]);
    })
    .catch(error => {
        // console.error("🚨 Error fetching order:", error);
        document.getElementById('orderData').innerHTML = `<p style="color: red; font-weight: bold;">Error: ${error.message}</p>`;
    });
}




  
function displayOrder(order) {
    const container = document.getElementById('orderData');
    container.innerHTML = ''; // Clear previous contents

    let trackingNumber = "Not Available";
    let trackingUrl = "Tracking link not available";
    let paymentStatus = "Unknown";
    let productTitles = order.line_items.map(item => item.title).join(", ");

    // Get tracking number
    if (order.fulfillments.length > 0 && order.fulfillments[0].tracking_numbers.length > 0) {
        trackingNumber = order.fulfillments[0].tracking_numbers[0];
        trackingUrl = getTrackingUrl(trackingNumber);
    }

    // Determine payment status
    paymentStatus = order.financial_status === 'paid' ? 'Prepaid' : 'Cash on Delivery (COD)';

    // Create order details
    const orderElement = document.createElement('div');
orderElement.innerHTML = `
    <table class="order_details">
        <tr>
            <th>Order ID</th>
            <td>${order.id}</td>
        </tr>
        <tr>
            <th>Order Name</th>
            <td>${order.name}</td>
        </tr>
        <tr>
            <th>Product Name</th>
            <td>${productTitles}</td>
        </tr>
        <tr>
            <th>Payment Status</th>
            <td>${paymentStatus}</td>
        </tr>
        <tr>
            <th>Tracking Link</th>
            <td>${trackingUrl}</td>
        </tr>
        <tr>
            <th>Total Price</th>
            <td>${order.total_price}</td>
        </tr>
        <tr>
            <th>Tracking Number</th>
            <td>${trackingNumber}</td>
        </tr>
        <tr>
            <th>Billing Address</th>
            <td>
                ${order.billing_address.first_name}, 
                ${order.billing_address.address1}, 
                ${order.billing_address.city}, 
                ${order.billing_address.zip}, 
                ${order.billing_address.phone}
            </td>
        </tr>
    </table>
`;


    container.appendChild(orderElement);
}

// Generate tracking URL based on tracking number format
function getTrackingUrl(trackingNumber) {
    if (trackingNumber.startsWith('1') && trackingNumber.length === 5) {
        return `<a href="https://track.amazon.in/tracking/${trackingNumber}" target="_blank">Track on Amazon</a>`;
    } else if (trackingNumber.startsWith('E') && trackingNumber.endsWith('IN') && trackingNumber.length === 13) {
        return `<a href="https://www.indiapost.gov.in/_layouts/15/dop.portal.tracking/trackconsignment.aspx" target="_blank">Track on India Post</a>`;
    } else if (trackingNumber.startsWith('8') && trackingNumber.length === 11) {
        return `<a href="https://bluedart.com/trackdartresultthirdparty?trackFor=0&trackNo=${trackingNumber}" target="_blank">Track on BlueDart</a>`;
    }
    return "Tracking link not available";
}
